const alwaysFilteredParentCodes = ['UU-HEALTH'];
const paymentsParentCode = 'UU-PAYMENTS';
const paymentChildCodes = ['UU-DISENROLLMENT', 'UU-ELIGIBILITY-AND-ENROLLMENT', 'UU-SERVICE-AUTHORIZATION'];
export default function filterServiceTypes(flatServiceTypes) {
  let hasPaymentsRole = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let parentServiceTypesToFilter = alwaysFilteredParentCodes;
  let childServiceTypesToFilter = [];
  if (hasPaymentsRole) {
    childServiceTypesToFilter = paymentChildCodes;
  } else {
    parentServiceTypesToFilter = [...alwaysFilteredParentCodes, paymentsParentCode];
  }
  return flatServiceTypes.filter(serviceType => {
    if (!serviceType.parent_id) {
      return !parentServiceTypesToFilter.includes(serviceType.code);
    }
    return !childServiceTypesToFilter.includes(serviceType.code) && !parentServiceTypesToFilter.includes(serviceType.parent_code);
  });
}
//# sourceMappingURL=filterServiceTypes.js.map